var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "advance-settings-component-container accordion" },
    [
      _c("h4", { staticClass: "form-section-title first accordion-toggle" }, [
        _vm._v("\n    " + _vm._s(_vm.string.showOnApp._title) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-container accordion-content" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 1 } },
                [
                  _c("custom-checkbox", {
                    on: { change: _vm.toggleShowOnApp },
                    model: {
                      value: _vm.event.showOnApp,
                      callback: function ($$v) {
                        _vm.$set(_vm.event, "showOnApp", $$v)
                      },
                      expression: "event.showOnApp",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 23 } }, [
                _c("p", { staticStyle: { margin: "0", padding: "0" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.string.showOnApp._description) +
                      "\n        "
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }